import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "blog-page" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  key: 0,
  class: "blog-list-slider"
}
const _hoisted_6 = { class: "blog-items--inner" }
const _hoisted_7 = { class: "blog-items--img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "blog-items--content" }
const _hoisted_10 = { class: "blog-tag-name" }
const _hoisted_11 = { class: "blog-items--dec" }
const _hoisted_12 = { class: "blog-search-section" }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "custom-row" }
const _hoisted_15 = { class: "blog-search" }
const _hoisted_16 = { class: "blog-select" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "blog-list-section" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "blog-list--inner" }
const _hoisted_21 = { class: "blog-box--inner" }
const _hoisted_22 = { class: "blog-list--img" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "blog-list--content" }
const _hoisted_25 = { class: "blog-tag-name" }
const _hoisted_26 = { class: "blog-des" }
const _hoisted_27 = { class: "blog-time-author" }
const _hoisted_28 = { class: "blog-time" }
const _hoisted_29 = { class: "blog-author" }
const _hoisted_30 = {
  key: 0,
  class: "pagination-box"
}
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_userFooter = _resolveComponent("userFooter")!
  const _component_ChatbotPopup = _resolveComponent("ChatbotPopup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader, { ref: "userHeader" }, null, 512),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", {
          class: "blog-top-section",
          style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/blog-banner-img.jpg')})` })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Blog", -1)),
            (_ctx.allBlogs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBlogs, (slider) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "blog-items",
                      key: slider.id
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: _ctx.getCdnImageAddress(slider.blogImage, `w_259,h_190/`),
                            width: "100%"
                          }, null, 8, _hoisted_8)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h2", null, [
                            _createVNode(_component_router_link, {
                              to: `/blogs/${slider.slug}`,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMenu()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(slider.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(slider.blogCategory), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.useStripHtml(_ctx.getBlogDescription(slider))), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4),
        _createElementVNode("section", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Enter your keywords…",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchedText) = $event)),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.fetchBlogs(), _ctx.fetchBlogsCount()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.searchedText]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("button", { class: "submit-icon" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("select", {
                  class: "selectbox",
                  id: "blogCategorySelectBox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedBlogCategory) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchBlogs(), _ctx.fetchBlogsCount()))
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Select the blog category", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogCategories, (category) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: category.id,
                      value: category.title
                    }, _toDisplayString(category.title), 9, _hoisted_17))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.searchedBlogCategory]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", null, "Displaying Posts (" + _toDisplayString(_ctx.blogsCount) + ")", 1),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "blog-list-box",
                  key: blog.id
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: _ctx.getCdnImageAddress(blog.blogImage, `w_95,h_95/`) ,
                        alt: ""
                      }, null, 8, _hoisted_23)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h4", null, [
                        _createVNode(_component_router_link, {
                          to: `/blogs/${blog.slug}`,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(blog.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(blog.blogCategory), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.useStripHtml(_ctx.getBlogDescription(blog))), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(blog.relativePostDate), 1),
                        _createElementVNode("div", _hoisted_29, "by " + _toDisplayString(blog.author), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("ul", null, [
                    (_ctx.currentPage !== 1)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1))),
                          class: "pagination-first"
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("button", null, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.totalPages != 1)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            onClick: ($event: any) => (_ctx.changePage(page))
                          }, [
                            _createElementVNode("a", {
                              href: "#",
                              class: _normalizeClass({ active: _ctx.currentPage === page })
                            }, _toDisplayString(page), 3)
                          ], 8, _hoisted_31))
                        }), 128))
                      : _createCommentVNode("", true),
                    (_ctx.currentPage !== _ctx.totalPages)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 2,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1))),
                          class: "pagination-last"
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("button", null, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter),
    _createVNode(_component_ChatbotPopup)
  ]))
}